import React from "react";
import { useSearch } from "../../../contexts/SearchContext";
import PlayerSearchResults from "../results/PlayerSearchResults";
import SearchPagination from "../SearchPagination";
import PlayerSearchForm from "./PlayerSearchForm";

const PlayerSearchBody = () => {
  const { searchResults, hasSearched } = useSearch();
  return (
    <div className="bcr-p-2">
      <PlayerSearchForm />
      <PlayerSearchResults data={searchResults} hasSearched={hasSearched} />
      <SearchPagination />
    </div>
  );
};

export default PlayerSearchBody;
